import SwalAlert from 'Global/Components/CommonComponents/SwalAlert/SwalAlert';
import { Post } from 'Xhr/Xhr';
import Cookies from 'js-cookie';

export const GetSamanKishToken = async (setToken, data) => {
  const idPatient = JSON.parse(
    Cookies.get('user') || ''
  )?.IdPatient;

  let currentUrl = window.location.href;
  currentUrl = document.URL;
  currentUrl = new URL(window.location);
  currentUrl = currentUrl.origin;

  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_GET_SAMAN_KISH_TOKEN}`,
    true,
    {
      Action: 'Token',
      TerminalId: '14051683',
      RedirectUrl: `${currentUrl}/verifysamankish`,
      ResNum: '',
      Amount: `${data.amount}`,
      CellNumber: `${data.mobile}`,
      GetMethod: true,
      idPatient: idPatient,
    }
  ).then((response) => {
    if (response.data.resCode === 1) {
      setToken(response.data.Data.token);
    } else {
      SwalAlert('error', response.data.resMessage, false);
    }
  });
};
